import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import InfoDialog from '@rio-cloud/rio-uikit/InfoDialog';

import { gaPush, TRACKING_CATEGORIES } from '../../configuration/setup/googleAnalytics';
import { useLocale } from '../../configuration/lang/langSlice';

type AccessInformationDialogProps = {
    show: boolean;
    link: string;
    onClose: () => void;
    onAccept: () => void;
};

export const AccessInformationDialog = (props: AccessInformationDialogProps) => {
    const { show, link, onClose, onAccept } = props;

    const locale = useLocale();

    // use locale for link. Note that we have to use the long-locale last part except for en-GB, where we use the first part en
    const lang = locale === undefined || locale === 'en-GB' ? 'en' : locale.split('-')[1].toLowerCase();
    const docuLink = `https://rio.cloud/${lang}/documents/manuals/exceptions/set-up-a-rule`;

    const handleHowToLink = () => {
        gaPush({
            category: TRACKING_CATEGORIES.NAVIGATION,
            label: 'Access information dialog',
            action: 'Clicked "How to setup a rule" link',
        });
    };

    return (
        <InfoDialog
            show={show}
            onClose={onClose}
            content={
                <div className='text-center'>
                    <FormattedMessage
                        id='intl-msg:notifications.ruleAccessInformation'
                        values={{
                            h5: chunk => <h5>{chunk}</h5>,
                            p: chunk => <p className='margin-bottom-10'>{chunk}</p>,
                        }}
                    />
                    <div className='margin-bottom-25'>
                        <a href={docuLink} target='_blank' rel='noreferrer' onClick={handleHowToLink}>
                            <span>
                                <FormattedMessage
                                    id='intl-msg:notifications.howToSetupARule'
                                    defaultMessage='How to setup a rule'
                                />
                            </span>
                            <span className='rioglyph rioglyph-new-window' />
                        </a>
                    </div>
                    <ButtonToolbar alignment='center' className='margin-bottom-20 margin-top-15'>
                        <Button bsStyle='muted-filled' onClick={onClose}>
                            <FormattedMessage id='intl-msg:notifications.cancel' defaultMessage='Cancel' />
                        </Button>
                        <a
                            href={link}
                            target='_blank'
                            rel='noreferrer'
                            className='btn btn-primary btn-icon-right'
                            onClick={onAccept}
                        >
                            <span className='rioglyph rioglyph-new-window' />
                            <FormattedMessage
                                id='intl-msg:notifications.openRuleEditor'
                                defaultMessage='Ok, open rule editor'
                            />
                        </a>
                    </ButtonToolbar>
                </div>
            }
        />
    );
};
